// Welle P1b: ein Formatierer für das ganze Schülerprofil — Datum nie als ISO,
// Noten mit Komma. Datumswerte kommen als 'YYYY-MM-DD…' (Kalenderdatum, keine Zeitzone).

const WT = ['So', 'Mo', 'Di', 'Mi', 'Do', 'Fr', 'Sa'];
const teile = (iso: string) => ({ j: iso.slice(0, 4), m: iso.slice(5, 7), t: iso.slice(8, 10) });
const istIso = (iso?: string | null): iso is string => !!iso && /^\d{4}-\d{2}-\d{2}/.test(iso);

/** 22.10.2026 */
export function datum(iso?: string | null): string {
  if (!istIso(iso)) return '';
  const { j, m, t } = teile(iso);
  return `${t}.${m}.${j}`;
}
/** 22.10. */
export function tm(iso?: string | null): string {
  if (!istIso(iso)) return '';
  const { m, t } = teile(iso);
  return `${t}.${m}.`;
}
/** Wochentag kurz: Do */
export function wt(iso?: string | null): string {
  if (!istIso(iso)) return '';
  return WT[new Date(iso.slice(0, 10) + 'T12:00:00Z').getUTCDay()];
}
/** Do 22.10. */
export function wtTm(iso?: string | null): string {
  return istIso(iso) ? `${wt(iso)} ${tm(iso)}` : '';
}
/** Do, 22.10. */
export function wtKommaTm(iso?: string | null): string {
  return istIso(iso) ? `${wt(iso)}, ${tm(iso)}` : '';
}

/**
 * Welle Z4: EIN Format für Schnitte — genau eine Nachkommastelle mit Komma (kaufmännisch
 * gerundet): 2,46 → „2,5“, 2,54 → „2,5“, 2,56 → „2,6“, 3 → „3,0“. Die Rechnung bleibt unverändert.
 */
export function note(n?: number | null): string {
  if (n == null || !Number.isFinite(n)) return '—';
  return (Math.round(n * 10 + 1e-9) / 10).toFixed(1).replace('.', ',');
}
/** Halbjahresnote: festgelegte Endnote als ganze Zahl, sonst der Schnitt mit einer Nachkommastelle */
export const notenWert = (n: { wert: number | null; status: string }): string =>
  n.status === 'final' && n.wert != null ? String(Math.round(n.wert)) : note(n.wert);
/**
 * Welle Z4: Stufe 1–6 für die Verteilung nach dem ANGEZEIGTEN Wert (eine Nachkommastelle):
 * bis x,5 zählt zur Note x (2,5 → 2), ab x,6 zur nächsten (2,6 → 3).
 */
export function notenStufe(n: number): number {
  const zehntel = Math.round(n * 10 + 1e-9);
  return Math.min(6, Math.max(1, Math.ceil((zehntel - 5) / 10)));
}
/** Zahl mit fester Stellenzahl und Komma */
export function zahl(n: number, stellen = 1): string {
  return n.toFixed(stellen).replace('.', ',');
}
/** „Englisch, Mathe und Deutsch“ */
export function aufzaehlung(liste: string[]): string {
  if (liste.length <= 1) return liste[0] ?? '';
  return `${liste.slice(0, -1).join(', ')} und ${liste[liste.length - 1]}`;
}
/** Initialen aus Vor- und Nachname */
export function initialen(vorname?: string | null, nachname?: string | null, name?: string): string {
  const v = (vorname ?? name?.split(' ')[0] ?? '').trim();
  const n = (nachname ?? name?.split(' ').slice(1).join(' ') ?? '').trim();
  return ((v[0] ?? '') + (n[0] ?? '')).toUpperCase() || '?';
}
/** Heute als YYYY-MM-DD in Ortszeit */
export const heuteIso = () => new Date().toLocaleDateString('sv-SE');
